import PageContainer from '@/common/components/PageContainer'

import { ChatLayout } from '../../components/ChatLayout'

export function ChatPage() {
	return (
		<PageContainer scrollable={false} className="p-2 md:px-2">
			<ChatLayout />
		</PageContainer>
	)
}
